//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibMember',
  props: {
    clickable: {
      default: true,
      type: Boolean
    },
    url: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    },
    statusLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.theme.primaryColor
      };
    },
    buttonColor: function buttonColor() {
      return this.theme.secondaryColor;
    },
    status: function status() {
      // TODO - make sure to update this to use i18n when signed off
      return this.isActive ? this.$t('manageTeam.active') : this.$t('manageTeam.inactive');
    }
  }
};